import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { TextComponent } from '@shared/components/text';
import { LegalService } from '../services/legal/legal.service';
import { LegalLinkComponent } from './legal-link.component';

@Component({
  selector: 'l-cookie-consent-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TextComponent, ButtonComponent, LegalLinkComponent],
  templateUrl: './cookie-consent-banner.component.html'
})
export class CookieConsentBannerComponent {
  private readonly legalService = inject(LegalService);

  private readonly acknowledgedLocally = signal(this.legalService.hasCookieNoticeAcknowledged());

  protected readonly visible = computed(() => !this.acknowledgedLocally());

  protected acknowledge(): void {
    this.legalService.acknowledgeCookieNotice();
    this.acknowledgedLocally.set(true);
  }
}
